// Landing-page Focus — the areas a person can say they look after.
//
// Shared so the api validates exactly the ids the web app offers.
//
// Design rule (the reason this is not Wiz's Lens): Focus REORDERS the
// platform overview, it never hides. Apps outside a person's focus stay
// on the page in a second group, and a critical item from any app is
// always shown. Several areas can be chosen at once; choosing none means
// "Everything".
/** Every selectable id. `leadership` is a whole-page mode, not an app set. */
export const FOCUS_AREA_IDS = [
    'people',
    'email',
    'endpoints',
    'exposure',
    'recovery',
    'automation',
    'leadership',
];
export const FOCUS_AREAS = [
    { id: 'people', label: 'People & awareness', description: 'Phishing simulations, training and insider risk', appKeys: ['aware', 'insider'] },
    { id: 'email', label: 'Email threats', description: 'Reported and detected malicious email', appKeys: ['xes'] },
    { id: 'endpoints', label: 'Endpoints & devices', description: 'Device posture, patching and EDR coverage', appKeys: ['posture'] },
    { id: 'exposure', label: 'Exposure & assets', description: 'Vulnerabilities, external attack surface, inventory and identity risk', appKeys: ['surface', 'exposure'] },
    { id: 'recovery', label: 'Backup & recovery', description: 'Snapshots, the immutable vault and restore drills', appKeys: ['resilience'] },
    { id: 'automation', label: 'Automation & AI', description: 'Agents, workflows, the AI Gateway and AI Security', appKeys: ['agents', 'orchestrate', 'ai-gateway', 'ai-security'] },
    { id: 'leadership', label: 'Leadership overview', description: 'Every app at a glance and only the most important items', appKeys: [] },
];
/** The most areas a person may store. Every id at once is just "Everything". */
export const FOCUS_MAX_AREAS = FOCUS_AREA_IDS.length;
//# sourceMappingURL=focus.js.map